import
{
  Container,
  StyledCard,
  RecommendedContainer,
  RecommendedText,
  StyledCardContent,
  StyledCardActions,
  IconAvatarContainer,
  FeatureLinesContainer,
} from './AddonDescriptionCard.styles';

import IconAvatar from '../../Avatars/IconAvatar/IconAvatar';
import AddonCardTitle from '../../Typography/AddonCardTitle/AddonCardTitle';
import FeatureLine from '../../Typography/FeatureLine/FeatureLine';
import OutlinedButton from '../../Buttons/OutlinedButton/OutlinedButton';
import SolidButton from '../../Buttons/SolidButton/SolidButton';
import StatusPill from '../../Pills/StatusPill/StatusPill';
import { BaseContext } from "../../../providers/Global/BaseProvider";
import { Box, Stack } from '@mui/material';
import Title from '../../Typography/Title/Title';
import { useEffect, useContext, useState } from "react";
import AddonCardPrices from '../../Typography/AddonCardPrices/AddonCardPrices';
const AddonDescriptionCard = ({
  selected,
  key,
  title,
  name,
  image,
  description,
  monthlyClubPrice,
  yearlyClubPrice,
  isSelected,
  isActive,
  onClick,
  onSubscribeClick
}) =>
{
  const [selectedAddon, setSelectedAddon] = useState("");
  const [dataLoading, setDataLoading] = useState(true);
  const baseContext = useContext(BaseContext);
  const getButtonText = () =>
  {
    if (isSelected !== undefined)
    {
      return isSelected ? "Selected" : "Select";
    }
    return "Select";
  };
  useEffect(() =>
  {
    if (
      !baseContext.baseData.loading

    )
    {
      setDataLoading(false);
      console.log('desc', selected);
      setSelectedAddon(selected);

    }
  }, [baseContext]);



  return (
    <Container>
      <StyledCard recommended={undefined}>
        <StyledCardContent>
          <Stack direction="column" spacing="1em">
            <AddonCardTitle text={title} />
            <Box>
              <img src={image} width="100%" alt=""/>
            </Box>
            <Box>{description}</Box>
          </Stack>
        </StyledCardContent>
        <StyledCardActions>
          <Stack direction="column" spacing="1em" sx={{ width: "100%", padding: "2em" }}>
            <AddonCardPrices
              monthlyClubPrice={monthlyClubPrice}
              yearlyClubPrice={yearlyClubPrice}>
            </AddonCardPrices>
            {
              isActive &&
              <StatusPill
                text={'Active'}
                isActive
              />
            }
            {
              isSelected && !isActive &&
              <SolidButton
                text={getButtonText()}
                onClick={onClick}
              />
            }
            {
              !isActive && !isSelected &&
              <Stack direction="row" justifyContent="center" spacing={1} sx={{ width: "100%" }}>
                <OutlinedButton
                  text="Subscribe"
                  onClick={(name) => { onSubscribeClick(name) }}
                  fullWidth
                />
              </Stack>
            }
          </Stack>
        </StyledCardActions>
      </StyledCard>
    </Container>
  );
};

export default AddonDescriptionCard;
